import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';
import useUserCan from '@/shared/services/helpers/role-access/role-access';

const PurchasesListContainer = React.lazy(
  () => import('../../containers/purchase-list/purchase-list.container')
);

const PurchaseAddContainer = React.lazy(
  () => import('../../containers/purchase-add/purchase-add.container')
);

const PurchaseDetailsContainer = React.lazy(
  () => import('../../containers/purchase-details/purchase-details.container')
);

const PurchaseEditContainer = React.lazy(
  () => import('../../containers/purchase-edit/purchase-edit.container')
);

export const PurchasesRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={(APP_ROUTES.PURCHASES_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
  },
  {
    path: (APP_ROUTES.PURCHASES_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.FINANCE_OFFICER,
            UserRole.OPERATION_MANAGER,
            UserRole.OPERATION_AGENT
          ]}
          component={PurchasesListContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.PURCHASES_MODULE.CHILDREN as RouteConfig).ADD.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.FINANCE_OFFICER]}
          component={PurchaseAddContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.PURCHASES_MODULE.CHILDREN as RouteConfig).DETAILS.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.FINANCE_OFFICER,
            UserRole.OPERATION_MANAGER,
            UserRole.OPERATION_AGENT
          ]}
          component={() => {
            const canAddPurchase = useUserCan([
              UserRole.ADMIN,
              UserRole.FINANCE_OFFICER,
              UserRole.OPERATION_MANAGER
            ]);
            return <PurchaseDetailsContainer canAddPurchase={canAddPurchase} />;
          }}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.PURCHASES_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.FINANCE_OFFICER]}
          component={PurchaseEditContainer}
        />
      </React.Suspense>
    )
  }
];
